__turbopack_context__.v({
  "body": "guSDDa_body",
  "divider": "guSDDa_divider",
  "fieldGroup": "guSDDa_fieldGroup",
  "info": "guSDDa_info",
  "infoLink": "guSDDa_infoLink",
  "infoText": "guSDDa_infoText",
  "label": "guSDDa_label",
  "projectLogo": "guSDDa_projectLogo",
  "projectName": "guSDDa_projectName",
  "readOnlyInput": "guSDDa_readOnlyInput",
  "removeBtn": "guSDDa_removeBtn",
  "required": "guSDDa_required",
});
